export const config = {
  title: "Alex The Plumber LLC",
  meta: {
    description:
      "Alex The Plumber LLC offers reliable and affordable plumbing services in Bronx, NY. Specializing in leak detection, water heater maintenance, backflow prevention, and emergency gas line services.",
    keywords: [
      "Plumbing Services Bronx NY",
      "Alex The Plumber LLC",
      "Leak Detection Bronx",
      "Water Heater Maintenance",
      "Emergency Gas Line Services",
      "Backflow Prevention",
      "Licensed Plumber Bronx",
    ],
    author: "Alex The Plumber LLC",
    canonicalUrl: "https://alextheplumberllc.com/",
  },
  sections: {
    header: {
      businessName: "Alex The Plumber LLC",
    },
    sectionB: {
      heroTitle: "Reliable Plumbing Solutions for You",
      heroSubtitle: "Affordable plumbing services for homes and businesses.",
      learnAboutText: "Explore Our Services",
      phoneNumber: "9176018701",
      phoneLabel: "(917) 601-8701",
      heroBackgroundImage:
        "https://img1.wsimg.com/isteam/getty/843814740/:/rs=w:2560", // Replace with actual image URL
      cardData: [
        {
          title: "Leak Detection and Repair",
          description:
            "Quickly detect and repair leaks to prevent further damage to your home or business.",
        },
        {
          title: "Water Heater Maintenance",
          description:
            "Extend the life of your water heater and prevent costly repairs with regular maintenance services.",
        },
        {
          title: "Emergency Gas Line Services",
          description:
            "24/7 emergency gas line services to address dangerous situations promptly and safely.",
        },
      ],
      description:
        "Alex The Plumber LLC provides top-notch plumbing services in Bronx, NY. From leak detection to emergency gas line repairs, trust our experienced professionals for quality workmanship.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "Comprehensive plumbing services tailored to meet your unique needs.",
      cards: [
        {
          title: "Backflow Prevention",
          description:
            "Install and maintain backflow prevention devices to keep your water supply safe and clean.",
          imageSrc:
            "https://img1.wsimg.com/isteam/getty/1327204419/:/rs=w:776,h:388,cg:true,m/cr=w:776,h:388", // Replace with actual image URL
          imageAlt: "Backflow Prevention",
        },
        {
          title: "Plumbing Inspections",
          description:
            "Thoroughly inspect your plumbing system to identify potential issues before they become major problems.",
          imageSrc:
            "https://img1.wsimg.com/isteam/getty/178425815/:/rs=w:776,h:388,cg:true,m/cr=w:776,h:388", // Replace with actual image URL
          imageAlt: "Plumbing Inspections",
        },
        {
          title: "Water Heater Maintenance",
          description:
            "Prevent costly repairs with our water heater maintenance services. ",
          imageSrc:
            "https://img1.wsimg.com/isteam/getty/2170643843/:/rs=w:776,h:388,cg:true,m/cr=w:776,h:388", // Replace with actual image URL
          imageAlt: "Kitchen and Bathroom Remodeling",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "Faucet Installation",
        "Sink Repair and Installation",
        "Toilet Installation",
        "Boiler Installation and Repair",
        "Hot Water Tank Installation and Repair",
      ],
    },
    sectionD: {
      aboutTitle: "About Us",
      aboutImage: {
        src: "https://img1.wsimg.com/isteam/getty/1409042417/:/rs=w:1280,h:853", // Replace with actual image URL
        alt: "Alex The Plumber LLC Team",
      },
      aboutText: [
        "Alex The Plumber LLC is a trusted plumbing service provider in Bronx, NY. Our team of experienced professionals is dedicated to delivering high-quality workmanship and exceptional customer service.",
        "We specialize in a wide range of plumbing services, ensuring that your home's plumbing system operates efficiently and reliably.",
      ],
    },
    sectionE: {
      profileImage:
        "https://img1.wsimg.com/isteam/ip/1b80db3c-dd40-4eca-9a39-64b6a426af70/alex-the-plumber-llc-typography-1.png/:/rs=w:400,h:400,cg:true,m/cr=w:400,h:400/qt=q:95", // Replace with actual image URL
      profileAlt: "Alex The Plumber LLC Logo",
      businessName: "Alex The Plumber LLC",
      contact: {
        phone: "9176018701",
        phoneLabel: "(917) 601-8701",
        email: "atplumberllc@gmail.com",
        website: "https://alextheplumberllc.com/",
        address: "150 E 165th St, Bronx, NY 10452",
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        twitter: null,
        linkedin: null,
        youtube: null,
      },
    },
    sectionF: {
      address: "150 E 165th St, Bronx, NY 10452",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3021.123456789!2d-73.9223456!3d40.8298765!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c2f6a123456789%3A0xabcdef1234567890!2s150%20E%20165th%20St%2C%20Bronx%2C%20NY%2010452!5e0!3m2!1sen!2sus!4v1614123456789!5m2!1sen!2sus",
    },
  },
};

export default config;
